export class PEGDetails {
  triggers: PEGinterface[] = [];
  actions: PEGinterface[] = [];
  conditions: PEGinterface[] = [];
  constructor() {
    let i = 0;
    triggersName.forEach((item: any) => {
      this.triggers.push({
        name: item,
        code: i,
        definition: triggersDefinitions[i] ?? '',
      });
      i++;
    });
    i = 0;
    conditionsName.forEach((item: any) => {
      this.conditions.push({
        name: item,
        code: i,
        definition: conditionsDefinitions[i] ?? '',
      });
      i++;
      if (i == 60) {
        i = 129;
      }
    });
    i = 0;
    actionsName.forEach((item: any) => {
      this.actions.push({
        name: item,
        code: i,
        definition: actionsDefinitions[i] ?? '',
      });
      i++;
    });
  }
}

export class PEGFlow {
  param: number;
  paramIndex: number;
  trigger: number;
  triggerModifier: number;
  condition1: number;
  condition1Modifier: number;
  condition2: number;
  condition2Modifier: number;
  action: number;
  actionModifier: number;
  logicalCondition2: string;

  constructor() {
    this.param = 0;
    this.paramIndex = 0;
    this.trigger = 0;
    this.triggerModifier = 0;
    this.condition1 = 0;
    this.condition1Modifier = 0;
    this.condition2 = 0;
    this.condition2Modifier = 0;
    this.action = 0;
    this.actionModifier = 0;
    this.logicalCondition2 = '';
  }
}

export interface PEGinterface {
  name: string;
  code: number;
  definition: string;
}

const triggersName = [
  ' ',
  'Power Up',
  'Wake Up',
  'Power Up or Wake Up',
  'Input High',
  'Input Low',
  'Input Equate',
  'Speed Above',
  'Speed Below',
  'Zone Entry',
  'Zone Exit',
  'GPS Acquired',
  'GPS Lost',
  'Comm Acquired',
  'Comm Lost',
  'Ignition On',
  'Ignition Off',
  'Time-Distance Update',
  'Timer Timeout',
  'Accumulator Above',
  'Time of Day',
  'Log Buffer Full',
  'Host Data',
  'Log Send Failure',
  'Wake Up on Input',
  'Wake Up on Timer',
  'Message Sent',
  'Message Acknowledged',
  'Message Send Failure',
  'Log Report Success',
  'Comm Shutdown',
  'Input Transition',
  'Any Zone Entry',
  'Any Zone Exit',
  'Time Elapsed',
  'Distance Traveled',
  'Log Active',
  'Message Received',
  'Any Message Received',
  'Environment Change',
  'Heading Change',
  'Special',
  'Moving',
  'Not Moving',
  'A/D Above',
  'A/D Below',
  'Comm Connected',
  'Accumulator Below',
  'Any Trigger',
  'Comm State Change',
  'Incoming Call',
  'Call State',
  'SMS Request Received',
  'Geo-Zone Entry',
  'Geo-Zone Exit',
  'Any Geo-Zone Entry',
  'Any Geo-Zone Exit',
  'Null SMS Message Received',
  'Network ID Change',
  '1-Bit-Bus ID Read',
  'Update Begun',
  'Update Complete',
  'Acceleration Detected',
  'Message Generated',
  'GPS Quality Fix',
  'GPS Quality Lost',
  'Accelerometer',
  'VBus State',
  'Motion Log Wrap',
  'VBus DTC Change',
  'Radio Jamming Detect',
  'Acceleration Event Detected',
  'Acceleration Alignment State',
  'VBus Event',
  'Accumulator Schedule',
  'Window Schedule',
  'Tow Detect',
  'Ack Received',
  'Hosted App',
  'Tilt Above',
  'Tilt Below',
];

const triggersDefinitions = [
  'The Event is not active',
  'The LMU has been powered up',
  'The LMU has woken from sleep',
  'The LMU has either been powered on or has woke from sleep',
  'The input specified in the Trigger Modifier field has transitioned from low to high.',
  'The input specified in the Trigger Modifier field has transitioned from high to low.',
  'The value specified by the Trigger Modifier matches the current states of all monitored inputs.',
  'The speed reported by the GPS receiver is equal to or has exceeded the value referenced by the Trigger Modifier',
  'The speed reported by the GPS receiver has dropped below the value referenced by the Trigger Modifier',
  'The LMU has entered the zone referenced by the Trigger Modifier.',
  'The LMU has exited the zone referenced by the Trigger Modifier.',
  'The GPS receiver has started reporting valid (2D or 3D Real-time) position updates',
  'The GPS receiver has stopped reporting valid position updates. (Last Known or Invalid)',
  'The wireless modem has been turned on, found a wireless network, found data service and has successfully connected to the data network.',
  'The wireless modem has lost its connection with the data network',
  "The LMU's Ignition input (input 0) has transitioned from low to high.",
  "The LMU's ignition input (input 0) has transitioned from high to low",
  'One of the Time-Distance settings (Time, Distance, Heading) has been exceeded in the active Time-Distance profile',
  'The timer value referenced by the Trigger Modifier has reached 0.',
  'The Accumulator value referenced by the Trigger Modifier is equal to or has exceeded is threshold value',
  'The current time of the LMU has passed the time referenced in the Trigger Modifier. This Trigger will fire on a wake-up if the time of day has passed while the LMU was sleeping.',
  "The LMU's Log space has been filled to more than 80%",
  'Not Active',
  "This Trigger will fire when the LMU's Log Send Sequence has expired",
  'The LMU has woken from sleep based on an input transition',
  'The LMU has woken from sleep based on a timer timeout.',
  'A User Message with the type specified in the Trigger Modifier has been sent to the Inbound address',
  'A User Message with the type specified in the Trigger Modifier has been sent to the Inbound address and been acknowledged',
  'A User Message with the type specified in the Trigger Modifier has been sent to the Inbound address but did not receive an acknowledge',
  'The LMU has successfully reported all of its Logged data.',
  'The wireless modem has been powered off',
  'The input specified in the Trigger Modifier field has transitioned from high to low or from low to high',
  'The LMU has entered one of the defined PEG Zones',
  'The LMU has exited one of the defined PEG Zones',
  'The time component of the active Time-Distance Profile has been exceeded',
  'The distance component of the active Time-Distance Profile has been exceeded',
  'The LMU has been forced to Log an Inbound message. This Event only fires once until the Log is successfully emptied or cleared.',
  'The LMU has received a User Message matching the type specified in the Trigger Modifier',
  'The LMU has received a User Message',
  'Any of the states in the Environment Mask referenced by the Trigger Modifier have changed.',
  'The heading component of the active Time-Distance Profile has been exceeded',
  'Not Active',
  'Impact Detection',
  'Tilt Detect',
  "The LMU's speed is equal to or has exceeded the Moving Speed Threshold Parameter.",
  "The LMU's speed has dropped below the Moving Speed Threshold Parameter.",
  'The internal A/D (A/D0) has exceeded the value referenced by the Trigger Modifier.',
  'The internal A/D (A/D0) has dropped below the value referenced by the Trigger Modifier.',
  'The LMU has successfully established a data connection with the wireless network (i.e. it has obtained an IP address)',
  'The Accumulator value referenced by the Trigger Modifier has dropped below it threshold value.',
  'Any other PEG Trigger has occurred',
  'The state of the wireless modem has changed. The available states are:',
  'The LMU has received an incoming voice call matching the Caller ID String Parameter. If a Caller ID string is not defined this Trigger will fire with any incoming call',
  'The state of the call the LMU is currently in has changed to the state referenced by the Trigger Modifier',
  'The LMU has received an SMS Request Message (!R<n>) matching the request type specified in the Trigger Modifier.',
  'The LMU has entered the Geo-Zone (Point or Polygon) referenced by the Trigger Modifier.',
  'The LMU has left the Geo-Zone (Point or Polygon) referenced by the Trigger Modifier.',
  'The LMU has entered any of the defined Geo-Zones (point or polygon)',
  'The LMU has left any of the defined Geo-Zones (point or polygon)',
  'The LMU has received an SMS message which has an empty body.',
  'The Carrier ID value has changed. That is, the LMU has moved to a new network.',
  'The 1Bit-Bus has just read an iButton ID value',
  'An Over-The Air Update has begun',
  'An Over-The Air Update has completed',
  'The acceleration of the LMU has exceeded the threshold referenced by the Trigger Modifiers',
  'The LMU has received a user message from either the Host or Aux Serial port.',
  'This trigger is fired when the GPS fix meets or exceeds the quality defined by S-Register 174.',
  'This trigger is fired when the GPS fix no longer meets (or exceeds) the quality defined by S-Register 174',
  "Accelerometer Event 'n' detected. (1=Impact; 0,2-255 reserved)",
  "Vehicle Bus State change to 'n'",
  'Long Motion Log wrap-around notification. Indicates buffer is starting a new overwrite cycle.',
  'Vehicle Bus DTC(Diagnostic Truoble Code) Status Change',
  'Radio Jamming Detection',
  "Acceleration Event has occurred defined by Acceleration Detection profile 'n'.",
  'Accelerometer Alignment State change',
  "A special notification from jPOD that a Vehicle Bus Event 'n' occured.'n' is extracted from the special message.(jPOD script requirements apply)",
  "Schedule defined by Accumulator 'n' has occurred",
  'Window Schedule defined by Param 286 has changed state.',
  "GPS-based towing detection trigger that fires if the unit exceeds the distance (in meters) for approximately 2 minutes that is stored in Parameter 1047. The 'center' is set at Ignition Off though it can improve its saved location if HDOP or Accuracy Estimate improves (much like Pinning). Release Notes for 3.0b",
  'Fires when an LMDirect ACK Message (Type-1) is received with an Ack of 0. Release Notes for 3.0b',
  "Initiated by Hosted Application program to signal PEG script with 'n', the modifier.",
  "Tilt above threshold for profile 'n' detected",
  "Tilt below threshold for profile 'n' detected",
];

const conditionsName = [
  '',
  'Ignition On',
  'Ignition Off',
  'Moving',
  'Not Moving',
  'Comm Available',
  'Comm Not Available',
  'GPS Acquired',
  'GPS Not Acquired',
  'Input High',
  'Input Low',
  'Timer Active',
  'Timer Inactive',
  'Time-Distance Active',
  'Time-Distance Inactive',
  'Day of Week',
  'Flag Set',
  'Flag Clear',
  'Log Active',
  'Comm and GPS Available',
  'Environment',
  'Environment Equate',
  'Inside Time of Day Window',
  'Outside Time of Day Window',
  'Accumulator Above',
  'Accumulator Below',
  'Comm State',
  'Log Inactive',
  'Input Compare',
  'PEG Flag Compare',
  'Time Valid',
  'Comm Select',
  'Log Full',
  'User Flag',
  'Call Status',
  'Speed Above',
  'Super Group',
  'Roaming',
  'PEG Enables',
  'Boot Reason',
  'Zone State',
  'PEG State',
  'Accumulator Equal',
  'Comm On',
  'GPS On',
  'Zone Enabled',
  '1BitBus Detect',
  'GPS Fix Quality',
  'Vbus State',
  'VBus DTC Status',
  'Radio Jamming',
  'Accel Alignment Status',
  'Acc Schedule Complete',
  'Window Schedule',
  'Accumulator Schedule',
  'Accumulator Pair',
  'Hosted App',
  'Tilt',
  'Condition Group',
  'Driver ID',
  'NOT Ignition On',
  'NOT Ignition Off',
  'NOT Moving',
  'NOT Not Moving',
  'NOT Comm Available',
  'NOT Comm Not Available',
  'NOT GPS Acquired',
  'NOT GPS Not Acquired',
  'NOT Input High',
  'NOT Input Low',
  'NOT Timer Active',
  'NOT Timer Inactive',
  'NOT Time-Distance Active',
  'NOT Time-Distance Inactive',
  'NOT Day of Week',
  'NOT Flag Set',
  'NOT Flag Clear',
  'NOT Log Active',
  'NOT Comm and GPS Available',
  'NOT Environment',
  'NOT Environment Equate',
  'NOT Inside Time of Day Window',
  'NOT Outside Time of Day Window',
  'NOT Accumulator Above',
  'NOT Accumulator Below',
  'NOT Comm State',
  'NOT Log Inactive',
  'NOT Input Compare',
  'NOT PEG Flag Compare',
  'NOT Time Valid',
  'NOT Comm Select',
  'NOT Log Full',
  'NOT User Flag',
  'NOT Call Status',
  'NOT Speed Above',
  'NOT Super Group',
  'NOT Roaming',
  'NOT PEG Enables',
  'NOT Boot Reason',
  'NOT Zone State',
  'NOT PEG State',
  'NOT Accumulator Equal',
  'NOT Comm On',
  'NOT GPS On',
  'NOT Zone Enabled',
  'NOT 1BitBus Detect',
  'NOT GPS Fix Quality',
  'NOT Vbus State',
  'NOT VBus DTC Status',
  'NOT Radio Jamming',
  'NOT Accel Alignment Status',
  'NOT Acc Schedule Complete',
  'NOT Window Schedule',
  'NOT Accumulator Scheduled Active',
  'NOT Accumulator Pair Equal',
  'NOT Hosted App',
  'NOT Tilt',
  'NOT Condition Group',
  'NOT Driver ID',
];

const conditionsDefinitions = [
  'no conditions on event trigger',
  'Ignition must be on for event to trigger',
  'Ignition must be off for event to trigger',
  'GPS tracking & has speed > 3 miles per hour for event to trigger',
  'GPS not tracking or has speed < 4 miles per hour for event to trigger',
  'Comm must be registered & acquired for event to trigger',
  'Comm must not be registered & acquired for event to trigger',
  'GPS must be acquired for event to trigger',
  'GPS must not be acquired for event to trigger',
  "Input 'n' must be high (voltage) for event to trigger",
  "Input 'n' must be low (voltage) for event to trigger",
  "Timer 'n' must be running for event to trigger",
  "Timer 'n' must be stopped for event to trigger",
  "Time-Dist Profile 'n' must be in use for event to trigger",
  "Time-Dist Profile 'n' must not be in use for event to trigger",
  "Day-of-Week must be in day-of-week profile 'n' for event to trigger  ",
  "PEG flag 'n' must be set (1) for event to trigger  ",
  "PEG flag 'n' must be clear (0) for event to trigger  ",
  'Log buffers must contain msgs for event to trigger',
  'COMM and GPS must be acquired for event to trigger',
  "PEG Environ State ANDed with EMask 'n' must be non-zero for event to trigger",
  "PEG Environ State ANDed with EMask 'n' must match EMask 'n+i' for event to trigger",
  'Current Time is within PEG TOD Window.  Window defined by Condition Index (See Note 1)',
  'Current Time is outside PEG TOD Window.  Window defined by Condition Index (See Note 1)',
  "Accumulator 'n' is above its threshold.",
  "Accumulator 'n' is below its threshold.",
  'Comm State bit-mapped compare.  Upper 4-bits are mask bits, lower 4 are state bits. b0=Network Service, b1=Data Service, b2=Connected (PPP/SLIP)',
  'Log buffers must be empty for event to trigger',
  "Inputs 1-3 match value 'n'.",
  "Lower 8 PEG Flags match value 'n'.",
  "Unit time is valid if 'n' is 1 or invalid if 'n' is 0.",
  'Comm Select setting comparison. Upper nibble is CommIndex and lower nibble is Inbound Addr index ',
  'True if Log is Full (>%80) ',
  'User Flag config byte bit-mapped compare.  Upper 4-bits are mask bits, lower 4 are state bits. ',
  'Call state and type bit-mapped compare. Upper 4-bits are mask bits, lower 4-bits are status bits.  Bits definitions: b0-1=CallState(0=Idle,1=Incoming,2=Calling,3=Active),b2-b3=Type (0=voice,1=data,2=posloc,3=other)',
  'True if current speed is equal to or greater than the speed trigger threshold specified by the Condition Index',
  "Supergroup compare.  Trigger must reference Supergroup 'n' for condition to be True. ",
  'True if the Comm radio is roaming onto another network. ',
  "True if the bit value 'n' in the PEG Enables parameter is True. 0>='n'<=31. ",
  "Boot Reason Compare. True if 'n' matches boot reason (0=Cold, 1=Factory, 2=OTADownload, 3=RadioPwrUp)",
  "True if current location is inside (bit7 of 'n' is 0) or outside (bit7 of 'n' is 1) the Zone identified by bits 0-6 of 'n' and the Zone is enabled.",
  "True is 'n' matches PEG State variable",
  "True if Accumulator 'n' equals its threshold.",
  'True if Comm is off',
  'True if GPS is off.',
  "True if Zone 'n' is enabled.",
  'True if a device is detected on 1-bit bus (iButton)',
  "True if a GPS fix meets or exceeds quality level determined by 'n'. 'n': 0=off, 1-7=levels 1-7 (see S-Reg174), 8=level set by S-174",
  'Vehicle Bus State (b0=Detected)',
  'Vehicle Bus DTC Status bit-mapped Compare.Upper 4-bits are mask bits, lower 4 are state bits.  b0=DTC filter0 match,b1=DTC filter1 match,b2=DTC filter2 match,b3=DTC filter3 match',
  'True if comm radio jamming detected',
  "True if Accelerometer Alignment State equals condition modifier 'n'",
  "Schedule repetition counter defined by Accumulator 'n' has reached its limit.",
  "True if the state of Window Schedule defined by Param 286 matches 'n' where upper 4-bits are mask bits, lower 4 bits are state bits.",
  "True if Accumulator Schedule 'n' is active.",
  'True if a pair of accumulators have the same value',
  "Hosted Application Program defined condition based on modifier 'n'",
  "True if profile 'n' tilt is above threshold",
  "True if Condition Group 'n' evaluates to TRUE",
  "True if any bits in 'n' have corresponding Driver ID match errors. Mode 1 match error is bit-7",
];

const actionsName = [
  '',
  'Send Report',
  'Log Report',
  'Send/Log Report',
  'Send Log',
  'Clear Log',
  'Stop Time-Distance Profile',
  'Start Time-Distance Profile',
  'Set Output',
  'Clear Output',
  'One-shot output',
  'Blink Output at 1Hz Rate',
  'Blink Output at 4 Hz Rate',
  'Start/Restart Timer',
  'Stop/Pause Timer',
  'Start/Resume Timer',
  'Clear Timer',
  'One-shot Timer',
  'Increment Accumulator',
  'Clear Accumulator',
  'Power Up GPS',
  'Power Down GPS',
  'Sleep (Timer)',
  'Sleep Enable',
  'Sleep Until Time of Day',
  'Output Word',
  'Start Time Accumulator',
  'Start Distance Accumulator',
  'Stop Accumulator',
  'Stop and Clear Accumulator',
  'Stop and Clear Timer',
  'Set Flag',
  'Clear Flag',
  'Send Accumulator Report',
  'Log Accumulator Report',
  'Send/Log Accumulator Report',
  'Display Position',
  'Comm Connect',
  'Comm Disconnect',
  'Save Environment',
  'Report Alert',
  'Send Special',
  'Move A/D value to Accumulator',
  'Send/Log Status Report',
  'Send Unacknowledged Event Report',
  'Send TAIP Report',
  'Start Max Speed Accumulator',
  'Start A/D Accumulator',
  'Decrement Accumulator',
  'Send Maintenance Report',
  'Jump',
  'Call',
  'Return',
  'End',
  'Move Zone States to Accumulator',
  'Power Up Modem/Comm Start',
  'Power Down Modem/Comm Off',
  'Send SMS Report',
  'Start Speed Accumulator',
  'Start Max A/D Value Accumulator',
  'Select Comm Profile',
  'Send Long Text Message',
  'Send Short Text Message',
  'Start Position Accuracy Accumulator',
  'Move PEG Flag states to Accumulator',
  'Set Application ID',
  'Send Text Status Message',
  'Start Geo-Zone Accumulation',
  'Set Text Attributes',
  'Start I/O State Accumulator',
  'Application Restart',
  '1-Bit Bus ID to Accumulator',
  'Serial Message',
  'Set Zone',
  'Enable Zone',
  'Disable Zone',
  'Dial Number',
  'Answer',
  'Hang-Up',
  'Set PEG State Variable',
  'Multi-Pulse Output',
  'Send Mini Report',
  'Log Mini Report',
  'Send Unacknowledged Mini Report',
  'Start Max Acceleration Accumulator',
  'Start Max Deceleration Accumulator',
  'Start RSSI Accumulator',
  'Start Cell ID Accumulator',
  'Divide Accumulators',
  'Send Binary',
  'Hibernate',
  'Start Temperature Accumulator',
  'Request Time Sync',
  'Move Temp Sensors to Accumulator',
  'Message Filter',
  'Accumulate Speed History',
  'Message Flush',
  'Add Record',
  'Capture Flush',
  'Vehicle Bus Action',
  'Start Vehicle Bus Command',
  'Send Null Message',
  'Serial Port Power Control',
  'Copy Accumulator',
  'Start Accumulating Average ADC',
  'Start Accumulating Network ID and Channel Number',
  'Comm Route',
  'Start Accumulating VBus Parameter',
  'Accelerometer Action',
  'Sleep Time Remaining in Accumulator',
  'Select Active Reporting Profile',
  'Start Accumulating VBus Indicator',
  'Send Motion Log Report',
  'Start Accumulating Battery Usage',
  'GPS Assist',
  'Start Accumulating LAC',
  'Sleep Controls',
  'Start Accumulator Schedule',
  'Flag Group Clear',
  'Start Accumulating Min ADC',
  'Wifi Action',
  'Hosted App',
  'Send Report via Table',
  'Flush Log',
  'Select Accumulator Destination',
  'Copy Accumulator to Destination Accumulator',
  'Restart Accumulating Default',
];

const actionsDefinitions = [
  'The Event does nothing',
  'The LMU will send an Event report with the Event Code value set to the Action Modifier. The message will be sent in Store and Forward Mode',
  'The LMU will Log an Event report with the Event Code value set to the Action Modifier. The message will be sent in Batch mode if the Log is not already in Store and Forward mode.',
  'The LMU will send an Event report with the Event Code value set to the Action Modifier. The message will be sent in Store and Forward Mode',
  'The LMU"s Log will be changed from Batch mode to Store and Forward mode. If the Log is already in Store and Forward mode, this Action will do nothing. If the send Log retry sequence has expired, another retry will be attempted.',
  'The LMU will delete all Logged records and re-format the Log space.',
  'The active Time-Distance profile will be stopped.',
  'The Time-Distance profile referenced by the Action Modifier will be started.',
  'The output referenced by the Action Modifier will be set.',
  'The output referenced by the Action Modifier will be cleared.',
  'The output referenced by the Action Modifier will be set for 1s then be cleared.',
  'The output referenced by the Action Modifier will be set and cleared every 1s.',
  'The output referenced by the Action Modifier will be set and cleared every 0.25s.',
  'The timer referenced by the Action Modifier will be started from its threshold value. When the Timer reaches 0 it will be restarted.',
  'The timer specified by the Action Modifier will be stopped at its current value.',
  'The timer referenced by the Action Modifier will be started from its current value. If the timer reaches 0, the timer will be restarted.',
  'The timer referenced by the Action Modifier will be reset to its threshold value.',
  'The timer referenced by the Action Modifier will be started from its threshold value. When the timer reaches 0 it will be stopped.',
  'The Accumulator referenced by the Action Modifier will be incremented by 1.',
  'The value of the Accumulator referenced by the Action Modifier will be cleared to 0.',
  'The GPS receiver will be powered on. IF the receiver is already on, it will be reset',
  'The GPS receiver will be powered on. IF the receiver is already on, it will be reset',
  'The GPS receiver will be powered off. If the receiver is already off, it will remain off',
  'The LMU will go to sleep for the duration specified by the timer referenced by the Action Modifier. If the timer"s value is 0, the LMU will go to sleep indefinitely.',
  'Enables the LMU to go to sleep.',
  'The LMU will go to sleep until the time referenced by the Action Modifier',
  'The LMU will set and clear its outputs to match the states indicated by the Action Modifier',
  'The Accumulator referenced by the Action Modifier will start counting seconds.',
  'The Accumulator referenced by the Action Modifier will start counting meters traveled.',
  'The Accumulator referenced by the Action Modifier will be stopped at its current value.',
  'The Accumulator referenced by the Action Modifier will be stopped and its value will be set to 0.',
  'The timer referenced by the Action Modifier will be stopped and its value will be reset to its threshold.',
  'The LMU will set the PEG flag referenced by the Action Modifier',
  'The LMU will clear the PEG flag referenced by the Action Modifier',
  'The LMU will create an Accumulator report and attempt to send it to the Inbound address. If the report cannot be sent, it will be Logged in store and forward mode.',
  'The LMU will create an Accumulator report and place it in the Log in batch mode.',
  'The LMU will create an Accumulator report and attempt to send it to the Inbound address. If the report cannot be sent, it will be Logged in store and forward mode.',
  'The LMU will send a POS or NMEA-RMC message to any device attached to its host serial port.',
  'The LMU will attempt to connect (i.e. dial data services) to the wireless network. If the LMU is already connected, this command will disconnect the data session and attempt to reconnect.',
  'The LMU will disconnect (i.e. drop the data service) from the wireless network. If the LMU is already disconnected this command does nothing.',
  'The LMU will save the Environment variables referenced by S-Register 127',
  'The LMU will send an Event report in three modes:',
  'The LMU will perform a "Special" Action based on the Action Modifier.',
  'Active CDMA Modem',
  'Send Acceleration Report Application Message',
  'The LMU will copy the current value of A/D 0 into the Accumulator referenced by the Action Modifier.',
  'The LMU will send a Log Status Report to the Inbound address. If the report cannot be sent, it will be Logged.',
  'The LMU will send an Event report using the Unacknowledged service. The report will not be Logged.',
  'The LMU will send a message using the TAIP settings. TAIP messages are never Logged.',
  'The LMU will sample its maximum speed value into the Accumulator referenced by the Action Modifier. The speed will be in cm/s',
  'The LMU will sample the A/D specified by the Action Modifier into the Accumulator specified by the Action Modifier.',
  'The Accumulator referenced by the Action Modifier will be decremented by 1. If the value is at 0, it will remain at 0.',
  'The LMU will create an ID report and send it based on the value of the Action Modifier.',
  'The LMU will jump to the Event index referenced by the Action Modifier. It will continue to process the Event list until the end.',
  'The LMU will jump to the Event index referenced by the Action Modifier. It can return to the Event index after the one that called it if a Return Action is issued.',
  'The LMU will return to the Event index after the last Event index to issue a Call Action.',
  'The LMU will jump to the End of the PEG Event list (i.e. it will stop processing Events for the specified Trigger)',
  'The LMU will sample the current state of the PEG zones into the Accumulator specified by the Action Modifier.',
  'The LMU will power on the wireless modem. If it is already on, it will be reset.',
  'The LMU will power down the wireless modem. If the modem is already off, it will remain off.',
  'The LMU will send an SMS Event report to the SMS Destination Address',
  'The LMU will sample its current speed into the Accumulator specified by the Action Modifier. The speed will be in cm/s',
  'The LMU will sample the maximum value of the A/D specified by the Action Modifier into the Accumulator specified by the Action Modifier.',
  'The LMU will change its comm settings to the profile specified by the Action Modifier',
  'The LMU will send the long text message specified by the Action Modifier to path specified by the Action Modifier',
  'The LMU will send the short text message specified by the Action Modifier to path specified by the Action Modifier',
  'The LMU will start sampling the position accuracy estimate (in meters) into the Accumulator specified by the Action Modifier.',
  'The LMU will copy the current state of all 16 PEG Flags into the Accumulator specified by the Action Modifier',
  'Sets the Application ID value specified by the Accumulator',
  'The LMU will send a Text Status message to the path specified by the Action Modifier.',
  'The LMU will sample the Geo-Zone ID of the last Geo-Zone boundary that was crossed into the Accumulator specified by the Action Modifier. The Geo-Zone will be mapped as follows:',
  'The LMU will set the Text Attributes for the Send Long and Send Short message Actions based on the value of the Action Modifier.',
  'The LMU will sample the states of the inputs and outputs into the Accumulator specified by the Action Modifier.',
  'The LMU is soft reset.',
  'This Action moves the ID value received from the 1-bit Bus to the Accumulators specified by the Action Modifier',
  'This Action will send a serial message to a designated serial port. The protocol and port to use with this message are defined in S173',
  'This Action will set the latitude and longitude of the Zone referenced by the Action Modifier to the current position of the LMU. The other zone values (Distance East, Distance North and Hysterisis) do not get updated.',
  'This Action will force the LMU to enable the zone referenced by the Action Modifier. Enabling and already enabled zone does nothing. Enabling a disabled zone will produce an immediate Zone Entry or Zone Exit Event.',
  'This Action will force the LMU to disable the zone reference by the Action Modifier. Disabled zones will not produce Zone Entry or Zone Exit Triggers.',
  'This command will force the LMU to dial a phone number to establish a voice call.',
  'This Action will force the LMU to answer an incoming voice call.',
  'This Action will force the LMU to hang-up and active voice call. It should have no effect on the data session.',
  'This Action will set the PEG State Variable to the value referenced in the Action Modifier',
  'This action will pulse an output for 0.5s in the pattern defined by the Action Modifier',
  'The LMU will send a Mini Event report with the Event Code value set to the Action Modifier. The message will be sent in Store and Forward Mode',
  'The LMU will Log a Mini Event report with the Event Code value set to the Action Modifier. The message will be sent in Batch mode if the Log is not already in Store and Forward mode.',
  'The LMU will send an unacknowledged Mini Event report with the Event Code value set to the Action Modifier.',
  'The LMU will sample its maximum acceleration value into the Accumulator referenced by the Action Modifier. The acceleration will be in cm/s2',
  'The LMU will sample its maximum deceleration value into the Accumulator referenced by the Action Modifier. The deceleration will be in cm/s2',
  'The LMU will sample the current RSSI value into the Accumulator referenced by the Action Modifier. The value is offset by +200dBm. For example an RSSI of -90 will show a value of 110.',
  'The LMU will sample the current Cell ID and Base Station ID for the network the LMU is communicating with.',
  'This action will divide the value of one accumulator by the value of the next. The result shall be placed in a third accumulator. Note that results shall be truncated.',
  'This action will send binary data represented by hexadecimal characters contained in a text string to the serial port defined in the Action Modifier.',
  'This action will force the LMU to go to sleep and only wake when it sees a transition on one of the inputs defined by the Action Modifier.',
  'The LMU will sample the current Temperature value received from the 1Bit-Bus into the Accumulator referenced by the Action Modifier. The value will have a 0.0625 °C LSB.',
  'The LMU will send a Time Sync request (i.e. LM Direct App Message Type 50) to the server specified by the Action Modifier',
  'This action will cause the LMU to count the number of temperature sensors connected to the 1Bit Bus into the accumulator specified by the Action Modifier.',
  'This Action allows the PEG script to block or allow serial data received from the Host or Aux port to be sent to the Inbound Server as a User Message',
  "This will start the specified accumulator saving the GPS Speed (in cm/sec) from 'n' seconds ago (up to 15 sec old). It can be used in conjunction with the Acceleration Triggers to report the speed of the vehicle prior to the trigger.",
  'This action will force the LMU to send the contents of the specified serial buffer to the Inbound Address as a User Message using the Send-Log transport mechanism.',
  'This action will add a record to the LMU"s 848 Capture Buffer using the contents defined by the Action Modifier and S-Register 171.',
  'This action will cause the LMU to send the contents of its Capture Buffer as an LM Direct Application Message of Type 120',
  'Based on the action modifier, this PEG Action will either Reset the jPOD or Hold the jPOD in Reset.',
  'This action will cause the jPOD to execute the command line dictated by the action modifier.',
  'This action will cause the LMU to send an Unacknowledged Null Message to the Inbound Address',
  'This action provide the ability to control the power to one or more serial ports',
  'This action copies the value in the Source Accumulator to the Destination Accumulator.',
  "Start A/D output averaging in accumulator 'n', upper nibble indicates A/D converter",
  "Start accumulating Cellular Network ID and Channel Number info in accumulator 'n'. GSM - MCC in upper 16-bits, Channel Number in lower 16-bits. CDMA and iDEN - not supported.",
  'Selects current communication routes used for reporting (n=0 (default) or n=1)',
  "Start accumulating Vehicle Bus Parameter in Accumulator 'n'",
  "Accelerometer Action 'n' (1=recalc tilt detect vector)",
  "Sleep for the time remaining in accumulator 'n'. The time remaining is the Acc 'n' Threshold minus the current Acc 'n' value.",
  'Selects the active Reporting Profile (255=disabled). This PEG Action is required to select the Active Reporting Profile when using the 32 Accumulator Reporting Format.',
  'Start accumulating Vehicle Bus Indicator in Accumulator',
  "Sends a Motion Log Report. If 'n'=0, send Short Log. Otherwise send 'n' records of Long Log",
  'Start accumulating battery usage in accumulator n',
  "Initiates a GPS Assist download request. 'n' selects mode.",
  "Start accumulating Local Area Code in accumulator 'n'. LAC in lower 16-bits.",
  'Define the characteristics for next sleep.',
  "Start a schedule defined by Accumulator 'n'",
  "Clear PEG flags in groups of 4 as defined by bits set in 'n'.",
  "Start min A/D output accumulation in accumulator 'n'.",
  'Controls WIFI radio profile selections.',
  "Notifies Hosted Application Program and passes modifier, 'n'.",
  'Send Event Report with Action Parameter as event code with report configuration based on lookup table index by event code.',
  "Flush out and delete all messages in log, 'n' : 0=selected Comm route log, 1=Log0, 2=Log1, 3=Log0 and Log1",
  "Defines the Accumlator to be the destination, 'n', for subsequent accumulator copies using 'ACT_ACC_COPY_FROM' action (see next)",
  "Copies Accumulator 'n' to the accumulator identified in the last 'ACT_ACC_DESTINATION' (see previous)",
  "Restart accumulating based on default acc-type/index settings Params #279,280). 'n' specifies the accumulator",
];
